import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";
import App from "./App.vue";

import "./assets/styles/main-style.scss";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import dateTime from "./plugins/dateTime";
import codemirror from "./plugins/codemirror";
import chart from "./plugins/directives/chart-options-editor.js";
import number from "./plugins/number";
import store from "./store/store";
import router from "./router";

import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/xml-fold";
import "codemirror/addon/fold/brace-fold";

import "codemirror/addon/mode/overlay";
import "codemirror/addon/mode/simple";
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/hint/show-hint";
import "codemirror/addon/hint/show-hint.css";

import "codemirror/mode/xml/xml";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/htmlmixed/htmlmixed";

import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
import exportingInit from "highcharts/modules/exporting";

exportingInit(Highcharts);
stockInit(Highcharts);
Highcharts.setOptions({
  colors: [
    vuetify.framework.theme.themes.light.primary,
    vuetify.framework.theme.themes.light.secondary,
    vuetify.framework.theme.themes.light.success,
    vuetify.framework.theme.themes.light.warning,
    vuetify.framework.theme.themes.light.info,
    vuetify.framework.theme.themes.light.error,
    vuetify.framework.theme.themes.light.accent
  ]
});
window.Highcharts = Highcharts;
Vue.use(HighchartsVue);

chart();
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  dateTime,
  codemirror,
  number,
  render: h => h(App)
}).$mount("#app");
